import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon';

export default class SelectButton extends React.Component {
  constructor(props) {
    super(props);
    // Enable debugging via 'localStorage.setItem('debug', true)' on the dev tools
    this.debugEnabled = localStorage.getItem('debug');
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(e) {
    const { onChange, buttonIndex } = this.props;

    onChange(buttonIndex, e);
  }

  render() {
    const { name, icon, id, selected, buttonIndex, buttonText } = this.props;

    const hasIcon = !icon || icon.length === 0;
    const classes = cx(
      'btn btn-outline-primary btn-block button button--question',
      {
        'active button--active': selected === true || id === selected,
        'button--no-icon': hasIcon,
        'button--icon': !hasIcon
      }
    );

    return (
      <div className="button--wrapper" data-toggle="buttons">
        <label className={classes}>
          {icon && <Icon name={icon} />}
          <input
            key={buttonIndex}
            type="radio"
            name={'group' + name}
            id={id}
            value={id}
            onChange={this.handleOnChange}
          />
          {buttonText}
          {this.debugEnabled && <div className="button__debug">{id}</div>}
        </label>
      </div>
    );
  }
}

SelectButton.propTypes = {
  id: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string,
  buttonIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};



// WEBPACK FOOTER //
// ./src/components/selectButton/SelectButton.js